import React from 'react';

import { Outlet, useResolvedPath } from '@gogame/screens';

import {
  useViewStateByPath,
  useParamsPathName,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';

import { BreadcrumbsContext } from './BreadcrumbsContext';

export const BreadcrumbsNode = () => {
  const { items, path: parentPath } = React.useContext(BreadcrumbsContext);
  const to = useResolvedPath('./');
  const path = useParamsPathName(items.length);
  const labelPath = path ? `${path}.name` : 'name';
  const label = useViewStateByPath(labelPath);

  return (
    <BreadcrumbsContext.Provider
      value={{
        items: [...items, { label, to }],
        parentPath,
        path,
      }}
    >
      <Outlet />
    </BreadcrumbsContext.Provider>
  );
};
